import React, { useEffect, useState } from "react";
import { Input } from "antd";
import { useNavigate, useParams, useLocation, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import NewMiniDrawer from "../../components/navMenu/menu-nav";
import { fetchProductById, createProduct, updateProduct } from "./action/action";
import { message } from "antd";
import {
    Box,
    Button,
    Card,
    CardContent,
    Divider,
    Stack,
    Switch,
    Typography,
} from "@mui/material";
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import { cardIconSx, newClientThemeVars } from "../../theme/globalStyle/globalStyle";
import { GlobalSuccessModal } from "../../components/modalGlobal/modalGlobal";
import './product.css';

function Product() {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();

    const [view, setOnlyView] = useState(location.state?.viewOnly || false);

    const userLogado = useSelector((state) => state.usuarioLogado);

    const user = useSelector((state) => state.user);

    const [product, setProduct] = useState("");
    const [description, setDescription] = useState("");
    const [activo, setActivo] = useState(false);
    const [created_at, setCreated_At] = useState("");
    const [uidShipperBackup, setUidShipperBackup] = useState("");
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [successModalTitle, setSuccessModalTitle] = useState("");

    useEffect(() => {
        if (id) {
            loadProduct();
        }

    }, [id]);

    if (userLogado <= 0) {
        return <Navigate to="/login" />;
    }

    // CARREGAR PRODUCT (EDIÇÃO)
    async function loadProduct() {
        try {
            const result = await fetchProductById(id);

            if (result.success && result.data) {
                const data = result.data;
                setProduct(data.product || "");
                setDescription(data.description || "");
                setActivo(data.activo || false);
                setCreated_At(data.created_at || "");
                setUidShipperBackup(data.uidShipper || "");
            }
            else {
                message.error("Produto não encontrado.");
                setTimeout(() => {
                    message.destroy();
                    navigate("/productList");
                }, 1500);
            }
        }
        catch (error) {
            message.error("Erro ao carregar o produto. Tente novamente.");
            console.error(error);
        }
    }

    // VALIDAÇÃO
    function validate() {
        if (!product) {
            message.warning("Atenção: verifique os campos: Produto.");
            return false;
        }

        return true;
    }

    // SALVAR / ATUALIZAR
    async function handleSave() {
        if (view) return;

        const isValid = validate();

        if (!isValid) {
            return;
        }

        const dados = {
            product: product,
            description: description,
            activo: activo,
            created_at: new Date(),
            uidShipper: user?.uidShipper,
            created_update: "",
        }

        try {
            const result = await createProduct(dados);

            if (!result.success) {
                throw new Error(result.error || "Erro ao salvar o produto");
            }

            setSuccessModalTitle("Produto cadastrado com sucesso!");
            setShowSuccessModal(true);
        }
        catch (error) {
            message.error("Erro ao salvar o produto. Tente novamente.");
            console.error(error);
        }
    };

    async function handleUpdate() {
        if (view) return;

        const isValid = validate();

        if (!isValid) {
            return;
        }

        const dados = {
            product: product,
            description: description,
            activo: activo,
            created_at: created_at,
            uidShipper: uidShipperBackup !== user?.uidShipper ? [...uidShipperBackup, user?.uidShipper] : uidShipperBackup,
            created_update: new Date(),
        }

        try {
            const result = await updateProduct(id, dados);

            if (!result.success) {
                throw new Error(result.error || "Erro ao atualizar o produto");
            }

            setSuccessModalTitle("Produto atualizado com sucesso!");
            setShowSuccessModal(true);
        }
        catch (error) {
            message.error("Erro ao atualizar o produto. Tente novamente.");
            console.error(error);
        }
    };

    const pageTitle = view ? "Visualizar produto" : id ? "Editar produto" : "Cadastro de produto";
    const pageSubtitle = view
        ? "Consulte os dados cadastrais do produto."
        : "Cadastre ou edite os produtos usados nas operacoes comerciais e de transporte.";

    return (
        <NewMiniDrawer
            divOpen={
                <Box className="product-form-page" sx={pageWrapperSx} style={newClientThemeVars}>
                    <Card sx={heroCardSx}>
                        <CardContent sx={{ p: { xs: 2, md: 3 } }}>
                            <Box className="product-form-hero">
                                <Stack spacing={1}>
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        <Box sx={cardIconSx}>
                                            <Inventory2OutlinedIcon sx={{ color: "#ffffff" }} />
                                        </Box>
                                        <Typography sx={heroTitleSx}>{pageTitle}</Typography>
                                    </Box>
                                    <Typography sx={heroSubtitleSx}>{pageSubtitle}</Typography>
                                </Stack>

                                <Box sx={statusPillSx}>
                                    {view ? "Somente leitura" : id ? "Atualizacao" : "Novo registro"}
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>

                    <Box className="product-form-form">
                        <SectionCard
                            icon={<Inventory2OutlinedIcon sx={{ color: "#ffffff" }} />}
                            title="Dados do produto"
                            subtitle="Nome, descricao e status do produto usado nas operacoes."
                        >
                            <Box className="product-form-grid">
                                <Field label="Produto *" span={6}>
                                    <Input
                                        disabled={view}
                                        value={product}
                                        onChange={(e) => setProduct(e.target.value)}
                                        placeholder="Nome do produto"
                                    />
                                </Field>

                                <Field label="Ativo" span={4}>
                                    <Switch
                                        checked={activo}
                                        disabled={view}
                                        onChange={(e) => setActivo(e.target.checked)}
                                    />
                                </Field>

                                <Field label="Descricao" span={6}>
                                    <Input.TextArea
                                        rows={3}
                                        disabled={view}
                                        value={description}
                                        onChange={(e) => setDescription(e.target.value)}
                                        placeholder="Descricao do produto"
                                    />
                                </Field>
                            </Box>
                        </SectionCard>
                    </Box>

                    <Card sx={actionsCardSx}>
                        <CardContent sx={{ p: { xs: 2, md: 2.4 } }}>
                            <Box className="product-form-actions">
                                <Button
                                    variant="outlined"
                                    startIcon={<ArrowBackOutlinedIcon />}
                                    onClick={() => navigate("/productList")}
                                    sx={secondaryActionSx}
                                >
                                    Cancelar
                                </Button>

                                {!view && (
                                    <Button
                                        variant="contained"
                                        startIcon={<SaveOutlinedIcon />}
                                        onClick={id ? handleUpdate : handleSave}
                                        sx={primaryActionSx}
                                    >
                                        {id ? "Atualizar" : "Salvar"}
                                    </Button>
                                )}
                            </Box>
                        </CardContent>
                    </Card>

                    <GlobalSuccessModal
                        open={showSuccessModal}
                        handleClose={() => {
                            setShowSuccessModal(false);
                            navigate("/productList");
                        }}
                        title={successModalTitle}
                    />
                </Box>
            }
        />
    );
}

function SectionCard({ icon, title, subtitle, children }) {
    return (
        <Card sx={sectionCardSx}>
            <CardContent sx={{ p: { xs: 2, md: 2.4 } }}>
                <Box className="product-form-section-heading">
                    <Box sx={cardIconSx}>{icon}</Box>
                    <Box>
                        <Typography sx={sectionTitleSx}>{title}</Typography>
                        <Typography sx={sectionSubtitleSx}>{subtitle}</Typography>
                    </Box>
                </Box>
                <Divider sx={{ mb: 2, borderColor: "rgba(1, 36, 67, 0.10)" }} />
                {children}
            </CardContent>
        </Card>
    );
}

function Field({ label, span = 3, children }) {
    return (
        <div className={`product-form-field product-form-span-${span}`}>
            <label>{label}</label>
            {children}
        </div>
    );
}

const pageWrapperSx = {
    p: { xs: 2, md: 3 },
    display: "flex",
    flexDirection: "column",
    gap: 2,
};

const heroCardSx = {
    borderRadius: "18px",
    border: "1px solid var(--new-client-primary-border)",
    boxShadow: "var(--new-client-shadow-soft)",
};

const sectionCardSx = {
    borderRadius: "var(--new-client-radius-lg)",
    border: "1px solid var(--new-client-primary-border)",
    boxShadow: "var(--new-client-shadow-section)",
    background: "var(--new-client-surface-soft)",
};

const actionsCardSx = {
    borderRadius: "var(--new-client-radius-lg)",
    border: "1px solid var(--new-client-primary-border)",
    boxShadow: "var(--new-client-shadow-section)",
};

const heroTitleSx = {
    color: "var(--new-client-primary)",
    fontWeight: 700,
    fontSize: "1.25rem",
};

const heroSubtitleSx = {
    color: "rgba(1, 36, 67, 0.74)",
    fontSize: "0.92rem",
    lineHeight: 1.5,
    maxWidth: 760,
};

const sectionTitleSx = {
    color: "var(--new-client-primary)",
    fontWeight: 700,
    fontSize: "1.05rem",
};

const sectionSubtitleSx = {
    color: "rgba(1, 36, 67, 0.62)",
    fontSize: "0.79rem",
    lineHeight: 1.45,
};

const statusPillSx = {
    border: "1px solid var(--new-client-primary-border)",
    borderRadius: "999px",
    color: "var(--new-client-primary)",
    background: "var(--new-client-primary-soft)",
    fontSize: "0.78rem",
    fontWeight: 700,
    px: 1.4,
    py: 0.6,
    whiteSpace: "nowrap",
};

const primaryActionSx = {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "10px",
    backgroundColor: "var(--new-client-primary)",
    minHeight: 40,
    px: 2,
    whiteSpace: "nowrap",
    "&:hover": {
        backgroundColor: "var(--new-client-primary-hover)",
    },
};

const secondaryActionSx = {
    textTransform: "none",
    fontWeight: 600,
    borderRadius: "10px",
    borderColor: "rgba(1, 36, 67, 0.28)",
    color: "var(--new-client-primary)",
    minHeight: 40,
    px: 2,
};

export default Product;